/* Welaza cart drawer: emirate switch for the delivery bar + upsell slider + one-click add */
(() => {
  const KEY = 'wz_zone';
  const OPEN_KEY = 'wz_ship_open';
  const readZone = () => { try { return localStorage.getItem(KEY) || 'DU'; } catch (e) { return 'DU'; } };
  const saveZone = (z) => { try { localStorage.setItem(KEY, z); } catch (e) {} };

  if (!customElements.get('wz-ship-bar')) {
    class WzShipBar extends HTMLElement {
      connectedCallback() {
        this.apply(readZone(), !WzShipBar.seen);
        WzShipBar.seen = true;
        let open = false;
        try { open = localStorage.getItem(OPEN_KEY) === '1'; } catch (e) {}
        this.setOpen(open, false);
        let chosen = null;
        try { chosen = localStorage.getItem(KEY); } catch (e) {}
        this.classList.toggle('needs-zone', !chosen);
        if (!chosen) this.querySelectorAll('.wz-ship__zone').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        this.addEventListener('click', (e) => {
          if (e.target.closest('.wz-ship__toggle')) {
            this.setOpen(!this.classList.contains('is-open'), true);
            return;
          }
          const btn = e.target.closest('.wz-ship__zone');
          if (!btn) return;
          saveZone(btn.dataset.zone);
          this.apply(btn.dataset.zone, false);
          document.querySelectorAll('wz-ship-bar').forEach((el) => {
            el.classList.remove('needs-zone');
            if (el !== this) el.apply(btn.dataset.zone, false);
          });
          document.dispatchEvent(new CustomEvent('wz:zone', { detail: { zone: btn.dataset.zone } }));
          if (window.matchMedia('(max-width: 767px)').matches) this.setOpen(false, true);
        });
      }
      setOpen(open, save) {
        this.classList.toggle('is-open', open);
        this.querySelectorAll('.wz-ship__toggle').forEach((b) => b.setAttribute('aria-expanded', String(open)));
        if (save) { try { localStorage.setItem(OPEN_KEY, open ? '1' : '0'); } catch (e) {} }
      }
      apply(zone, intro) {
        let state = this.querySelector(`.wz-ship__state[data-zone="${zone}"]`);
        if (!state) { zone = 'DU'; state = this.querySelector('.wz-ship__state[data-zone="DU"]'); }
        if (!state) return;
        this.querySelectorAll('.wz-ship__state').forEach((el) => { el.hidden = el !== state; });
        this.querySelectorAll('.wz-ship__zone').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.zone === zone)));
        this.dataset.state = state.dataset.state;
        if (intro) {
          this.classList.add('is-intro');
          requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-intro')));
        }
      }
    }
    customElements.define('wz-ship-bar', WzShipBar);
  }

  if (!customElements.get('wz-upsell')) {
    class WzUpsell extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.wz-upsell__grid');
        if (!this.grid) return;
        this.cards = [...this.grid.querySelectorAll('.wz-upsell__card')];
        this.dots = [...this.querySelectorAll('.wz-upsell__dot')];
        this.prev = this.querySelector('.wz-upsell__arrow[data-dir="-1"]');
        this.next = this.querySelector('.wz-upsell__arrow[data-dir="1"]');
        this.update = this.update.bind(this);
        this.grid.addEventListener('scroll', () => requestAnimationFrame(this.update), { passive: true });
        this.querySelectorAll('.wz-upsell__arrow').forEach((b) => b.addEventListener('click', () => {
          const step = this.cards[1] ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.grid.clientWidth;
          const perView = Math.max(1, Math.floor((this.grid.clientWidth + 2) / step));
          this.grid.scrollBy({ left: Number(b.dataset.dir) * step * perView, behavior: 'smooth' });
        }));
        this.ro = new ResizeObserver(this.update);
        this.ro.observe(this.grid);
        this.update();
      }
      disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
      update() {
        const g = this.grid;
        const scrollable = g.scrollWidth > g.clientWidth + 2;
        this.classList.toggle('is-scrollable', scrollable);
        const left = g.scrollLeft, right = left + g.clientWidth, base = g.offsetLeft;
        this.cards.forEach((c, i) => {
          const a = c.offsetLeft - base, b = a + c.offsetWidth;
          const visible = Math.min(b, right) - Math.max(a, left) > c.offsetWidth * 0.5;
          if (this.dots[i]) this.dots[i].classList.toggle('is-active', visible);
        });
        if (this.prev) this.prev.disabled = left <= 2;
        if (this.next) this.next.disabled = right >= g.scrollWidth - 2;
      }
    }
    customElements.define('wz-upsell', WzUpsell);
  }

  if (window.__wzUpsellBound) return;
  window.__wzUpsellBound = true;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.wz-upsell__add');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.remove('is-error');
    btn.classList.add('is-loading');
    try {
      const res = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] })
      });
      const data = await res.json();
      btn.classList.remove('is-loading');
      if (!res.ok || data.status) {
        btn.classList.add('is-error');
        const t = btn.querySelector('.wz-upsell__add-text');
        if (t) t.textContent = data.description || data.message || 'Unavailable';
        return;
      }
      btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('cart:reload'));
    } catch (err) {
      console.error('[wz-upsell]', err);
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
    } finally {
      setTimeout(() => { btn.disabled = false; }, 1200);
    }
  });
})();
